import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PaymentReturnPage } from '@/pages/profile/payment-return/ui/PaymentReturnPage'

const bankReference = z
  .union([z.string(), z.number()])
  .transform((value) => String(value))
  .catch('')

const paymentReturnSearchSchema = z.object({
  order_reference: bankReference,
  payment_reference: bankReference,
})

export const Route = createFileRoute('/payment-return')({
  validateSearch: paymentReturnSearchSchema,
  component: PaymentReturnPage,
})
